import { MerchantsShowNotificationsFormValues } from 'pages/Merchants/MerchantsShow/MerchantsShowNotifications/components/MerchantsShowNotificationsForm/MerchantsShowNotificationsForm';
import { getMerchantNotificationData } from 'pages/Merchants/MerchantsShow/MerchantsShowNotifications/utils/getMerchantNotificationData';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useCreate, useNotify } from 'react-admin';

import { useGetMerchantNotificationsEventNames } from './useGetMerchantNotificationsEventNames';

type UseCreateMerchantNotificationReturnValue = {
  isLoading: boolean;
  createMerchantNotification: (data: MerchantsShowNotificationsFormValues) => void;
};

export function useCreateMerchantNotification(
  merchantId: string,
  onSuccess: VoidFunction,
): UseCreateMerchantNotificationReturnValue {
  const translate = useTypedTranslate();

  const { eventNames } = useGetMerchantNotificationsEventNames();

  const [create, { isLoading }] = useCreate();
  const notify = useNotify();

  const createMerchantNotification = (values: MerchantsShowNotificationsFormValues) => {
    const data = getMerchantNotificationData(values, merchantId, eventNames);
    create(
      'merchant_notification_settings',
      { data },
      {
        onSuccess: () => {
          onSuccess();
          notify(translate('app.merchantsShowNotifications.notificationSettingsCreated'), {
            type: 'success',
          });
        },
        onError: (error) => {
          notify(
            `${translate('app.common.error')}: ${error as string}` ||
              translate('app.merchantsShowNotifications.notificationSettingsCreationError'),
            {
              type: 'error',
            },
          );
        },
      },
    );
  };

  return { isLoading, createMerchantNotification };
}
